/**
 * @generated SignedSource<<a64a3b32486811f4cb221ddc55e92a8c>>
 * @relayHash 922c40736c3ddb85254be6292efd27f6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 80175ba20e2a5a5011c4fb150e0b72b1e309ac3de1ca4a30d52ba5aed5debe2d

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceContentPerformanceContentType = "BLOG_POST" | "LIVE_PAGE" | "PAGE" | "%future added value";
export type ConfluenceLoadTimeRating = "FAST" | "MODERATE" | "SLOW" | "%future added value";
export type ConfluenceContentPerformanceFilters = {
  contentType?: ReadonlyArray<ConfluenceContentPerformanceContentType | null | undefined> | null | undefined;
  ownerId?: ReadonlyArray<string | null | undefined> | null | undefined;
  rating?: ReadonlyArray<ConfluenceLoadTimeRating | null | undefined> | null | undefined;
  spaceId?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type useContentMetricsQuery$variables = {
  after?: string | null | undefined;
  cloudId: string;
  endTimestamp?: string | null | undefined;
  filters?: ConfluenceContentPerformanceFilters | null | undefined;
  first: number;
  searchTerm?: string | null | undefined;
  startTimestamp: string;
};
export type useContentMetricsQuery$data = {
  readonly confluence_contentPerformanceList: {
    readonly nodes: ReadonlyArray<{
      readonly content: {
        readonly contentId: string;
        readonly contentTitle: string;
        readonly link: string;
      };
      readonly contentOwner: {
        readonly displayName: string;
        readonly id: string;
      };
      readonly id: string;
      readonly loadTimeRating: ConfluenceLoadTimeRating;
      readonly medianLoadTime: number;
      readonly operations: ReadonlyArray<{
        readonly operation: string;
        readonly targetType: string;
      } | null | undefined>;
      readonly space: {
        readonly id: string;
        readonly name: string | null | undefined;
      };
      readonly views: number;
    } | null | undefined>;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
      readonly startCursor: string | null | undefined;
    };
    readonly totalCount: number;
  } | null | undefined;
};
export type useContentMetricsQuery = {
  response: useContentMetricsQuery$data;
  variables: useContentMetricsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endTimestamp"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchTerm"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startTimestamp"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
      },
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "endTimestamp",
        "variableName": "endTimestamp"
      },
      {
        "kind": "Variable",
        "name": "filters",
        "variableName": "filters"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "searchTerm",
        "variableName": "searchTerm"
      },
      {
        "kind": "Variable",
        "name": "startTimestamp",
        "variableName": "startTimestamp"
      }
    ],
    "concreteType": "ConfluenceContentPerformanceConnection",
    "kind": "LinkedField",
    "name": "confluence_contentPerformanceList",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceContentPerformance",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v7/*: any*/),
          {
            "concreteType": "ConfluenceContentPerformanceContent",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "contentTitle"
              },
              {
                "kind": "ScalarField",
                "name": "link"
              },
              {
                "kind": "ScalarField",
                "name": "contentId"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "loadTimeRating"
          },
          {
            "kind": "ScalarField",
            "name": "medianLoadTime"
          },
          {
            "kind": "ScalarField",
            "name": "views"
          },
          {
            "concreteType": "ConfluenceContentPerformanceSpace",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "kind": "ScalarField",
                "name": "name"
              }
            ]
          },
          {
            "concreteType": "ConfluenceContentPerformanceUser",
            "kind": "LinkedField",
            "name": "contentOwner",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "kind": "ScalarField",
                "name": "displayName"
              }
            ]
          },
          {
            "concreteType": "ConfluenceContentPerformanceOperationCheckResult",
            "kind": "LinkedField",
            "name": "operations",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "operation"
              },
              {
                "kind": "ScalarField",
                "name": "targetType"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "ConfluenceContentPerformancePageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "hasNextPage"
          },
          {
            "kind": "ScalarField",
            "name": "endCursor"
          },
          {
            "kind": "ScalarField",
            "name": "startCursor"
          },
          {
            "kind": "ScalarField",
            "name": "hasPreviousPage"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "totalCount"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useContentMetricsQuery",
    "selections": (v8/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "useContentMetricsQuery",
    "selections": (v8/*: any*/)
  },
  "params": {
    "cacheID": "922c40736c3ddb85254be6292efd27f6",
    "id": "80175ba20e2a5a5011c4fb150e0b72b1e309ac3de1ca4a30d52ba5aed5debe2d",
    "metadata": {},
    "name": "useContentMetricsQuery",
    "operationKind": "query",
    "text": "query useContentMetricsQuery($cloudId:ID!,$first:Int!,$after:String,$searchTerm:String,$filters:ConfluenceContentPerformanceFilters,$startTimestamp:String!,$endTimestamp:String){confluence_contentPerformanceList(cloudId:$cloudId,first:$first,after:$after,searchTerm:$searchTerm,filters:$filters,startTimestamp:$startTimestamp,endTimestamp:$endTimestamp){nodes{id,content{contentTitle,link,contentId},loadTimeRating,medianLoadTime,views,space{id,name},contentOwner{id,displayName},operations{operation,targetType}},pageInfo{hasNextPage,endCursor,startCursor,hasPreviousPage},totalCount}}"
  }
};
})();

(node as any).hash = "8f6bf344b8b6f92f6a47f17cb158ef71";

export default node;
